// Tipos base Mapeamentos
export interface BaseEntity {
  _id: string;
  created_at: Date;
  updated_at: Date;
}

// Interfaces para paginação
export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  pages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: PaginationMeta;
}

// Enums
export enum AbordagemType {
  DETALHADA = 'detalhada',
  SIMPLIFICADA = 'simplificada'
}

export enum StatusVersao {
  PENDENTE = 'Pendente',
  ENVIADO = 'Enviado',
  AGUARDANDO_RESPOSTAS = 'Aguardando respostas',
  CONCLUIDO = 'Concluído'
}

export enum TipoDado {
  SENSIVEL = 'sensivel',
  COMUM = 'comum'
}

export enum QuantidadeTitular {
  ATE_99 = '1 a 99 pessoas',
  ATE_999 = '100 a 999 pessoas',
  ATE_9999 = '1.000 a 9.999 pessoas',
  ATE_99999 = '10.000 a 99.999 pessoas',
  ATE_999999 = '100.000 a 999.999 pessoas',
  MAIS_1M = '+ 1.000.000 pessoas',
  NAO_ESTIMAVEL = 'Não é possivel estimar'
}

export enum FaixaEtaria {
  CRIANCAS = 'Crianças (até 12 anos incompletos)',
  ADOLESCENTES = 'Adolescentes (13 a 18 anos)',
  ADULTOS = 'Adultos (18 a 60 anos)',
  IDOSOS = 'Idosos (+ de 60 anos)'
}

export enum OrigemDados {
  TITULAR = 'Fornecido pelo titular de dados',
  TERCEIROS = 'Fornecidos por terceiros',
  INTERNO = 'Fornecidos por outro departamento ou área interna'
}

export enum ConsentimentoTitular {
  NAO_SABE = 'O Titular não sabe que seus dados estão sendo usados',
  SABE_NAO_AUTORIZOU = 'O Titular sabe, mas não autorizou o uso',
  SABE_AUTORIZOU = 'O Titular sabe e autorizou o uso dos dados'
}

export enum FrequenciaColeta {
  CONTINUO = 'Contínuo ou em tempo real',
  SEMANAL = 'Semanal',
  MENSAL = 'Mensal',
  SEMESTRAL_ANUAL = 'Semestral ou Anual',
  UNICA_VEZ = 'Uma única vez'
}

export enum BasesLegaisComuns {
  CONSENTIMENTO = 'Consentimento pelo titular',
  OBRIGACAO_LEGAL = 'Cumprimento de obrigação legal ou regulatória',
  POLITICAS_PUBLICAS = 'Para execução de políticas públicas previstas em leis ou regulamentos',
  ESTUDOS_PESQUISA = 'Realização de estudos por órgão de pesquisa',
  EXECUCAO_CONTRATO = 'Execução de contrato ou de procedimentos preliminares',
  EXERCICIO_DIREITOS = 'Exercício regular de direitos em processo judicial, administrativo ou arbitral',
  PROTECAO_VIDA = 'Proteção da vida ou da incolumidade física do titular ou de terceiro',
  TUTELA_SAUDE = 'Tutela da saúde, exclusivamente, em procedimento realizado por profissionais da saúde, serviços de saúde ou autoridade sanitária.',
  LEGITIMO_INTERESSE = 'Legítimo Interesse',
  PROTECAO_CREDITO = 'Proteção do crédito'
}

export enum BasesLegaisSensiveis {
  CONSENTIMENTO = 'Consentimento',
  OBRIGACAO_LEGAL = 'Cumprimento de obrigação legal ou regulatória pelo controlador;',
  POLITICAS_PUBLICAS = 'Compartilhamento de dados necessários à execução, pela administração pública, de políticas públicas previstas em leis ou regulamentos;',
  ESTUDOS_PESQUISA = 'Realização de estudos por órgão de pesquisa;',
  EXERCICIO_DIREITOS = 'Exercício regular de direitos, inclusive em contrato e em processo judicial, administrativo e arbitral;',
  PROTECAO_VIDA = 'Proteção da vida ou da incolumidade física do titular ou de terceiros;',
  TUTELA_SAUDE = 'Tutela da saúde, em procedimento realizado por profissionais da área da saúde ou por entidades sanitárias;',
  PREVENCAO_FRAUDE = 'Garantia da prevenção à fraude e à segurança do titular, nos processos de identificação e autenticação de cadastro em sistemas eletrônicos'
}

export enum TipoCompartilhamento {
  DEPARTAMENTO_INTERNO = 'Departamento interno',
  PESSOA_JURIDICA = 'Pessoa jurídica externa',
  PESSOA_FISICA = 'Pessoa física externa',
  NAO_HA = 'Não há compartilhamento'
}

export enum FormaCompartilhamento {
  PAPEL = 'Papel',
  CD_DVD = 'CD/DVD',
  PEN_DRIVE = 'Pen-drive',
  HD_EXTERNO = 'HD Externo',
  CARTAO_SD = 'Cartão SD',
  MICRO_SD = 'MicroSD',
  NUVEM = 'Drive de armazenamento em nuvem (Google Drive; Dropbox; Sharepoint; Onedrive; Icloud)',
  SFTP = 'Transferência por sistemas (STFP)',
  PLATAFORMAS_LICENCIADAS = 'Plataformas de Comunicação Licenciadas (Teams; Google Workplace ou Similiar)',
  EMAIL = 'E-mail',
  SERVICOS_TERCEIROS = 'Serviço de Transferência de Arquivos de Terceiros (Ex: Wetransfer)',
  REDES_SOCIAIS = 'Redes Sociais (Facebook; Linkedin)',
  MENSAGENS = 'Aplicativo de Mensagens (WhatsApp, Telegram, WeChat)'
}

export enum PrazoGuarda {
  NAO_DEFINIDO = 'Não Definido',
  LEI_REGULAMENTO = 'Por prazo de guarda definido em lei ou regulamento',
  DEFINIDO_SEM_LEI = 'Por prazo de guarda definido, mas sem previsão em lei ou regulamento',
  SEM_PRAZO_COM_JUSTIFICATIVA = 'Sem prazo de guarda definido, mas com justificativa conhecida pela organização'
}

export enum TipoRelatorio {
  GERAL = 'geral',
  QUESTIONARIO_DETALHADO = 'questionario_detalhado',
  TITULARES = 'titulares',
  ESTATISTICAS = 'estatisticas'
}

export enum FormatoRelatorio {
  PDF = 'pdf',
  EXCEL = 'excel',
  CSV = 'csv'
}

// Interfaces principais
export interface Cliente {
  _id: string;
  nome: string;
  razao_social?: string;
}

export interface Area extends BaseEntity {
  description: string;
  cliente_id?: string;
  padrao: boolean;
}

export interface Dado extends BaseEntity {
  departamento?: string;
  categoria?: string;
  nome: string;
  description?: string;
  tipo: TipoDado;
}

export interface Pergunta extends BaseEntity {
  description: string;
  norma?: string;
  recomendacao?: string;
  obs?: string;
  tipo: string;
  placeholder?: string;
  ordem?: number;
  opcoes: {
    alternativa?: string;
    grau_descricao?: string;
    grau?: number;
    probabilidade?: number;
    impacto?: number;
  }[];
  required: boolean;
  dependencia: {
    pergunta_id: string;
    value: string;
    tipo: string;
  }[];
  inativo: boolean;
}

export interface Processo extends BaseEntity {
  description: string;
  norma?: string;
  recomendacao?: string;
  introducao?: string;
  tags: string[];
  cliente_id?: string;
  dependencia?: string;
}

export interface Questionario extends BaseEntity {
  cliente_id?: string;
  nome: string;
  abordagem?: AbordagemType;
  areas: string[];
  inativo?: boolean;
}

export interface QuestionarioCapitulo extends BaseEntity {
  questionario_id: string;
  capitulo_id: string;
  areas_id: string[];
  descricao_personalizada?: string;
  inativo?: boolean;
}

export interface VersaoRespostas extends BaseEntity {
  questionario_id: string;
  prazo?: Date;
  respostas: number;
  status: StatusVersao;
}

export interface Resposta extends BaseEntity {
  value: string[];
  questionario_perguntas_id?: string;
  user_id: string;
  versao_respostas: string;
}

export interface AreaCompartilhada {
  area_id: string;
  forma: FormaCompartilhamento;
}

export interface Externo {
  fornecedor_id: string;
  forma: FormaCompartilhamento;
}

export interface DadoTitular {
  dado_id: string;
  motivo?: string;
  origem: OrigemDados;
  consentimento_titular: ConsentimentoTitular;
  nome_dep_interno?: string;
  frequencia: FrequenciaColeta;
  bases_legais_comuns?: BasesLegaisComuns;
  bases_legais_sensiveis?: BasesLegaisSensiveis;
  compartilhamento: TipoCompartilhamento[];
  areas_compartilhadas: AreaCompartilhada[];
  externos: Externo[];
  internacional: boolean;
  paises?: string;
  local: string[];
  prazo: PrazoGuarda;
  norma?: string;
}

export interface Titular extends BaseEntity {
  relacao_id: string;
  categoria?: string;
  quantidade?: QuantidadeTitular;
  faixa_etaria: FaixaEtaria[];
  dados: DadoTitular[];
  inativo: boolean;
  
  // Observações
  obs_coleta?: string;
  obs_processamento?: string;
  obs_compartilhamento?: string;
  obs_armazenamento?: string;
  
  // Finalidades
  finalidade_coleta?: string;
  finalidade_processamento?: string;
  finalidade_compartilhamento?: string;
  finalidade_armazenamento?: string;
  
  // Medidas de segurança
  medidas_coleta?: string;
  medidas_processamento?: string;
  medidas_compartilhamento?: string;
  medidas_armazenamento?: string;
}

// Interfaces para estatísticas
export interface EstatisticasGerais {
  total_questionarios: number;
  questionarios_concluidos: number;
  total_titulares: number;
  categorias_titulares: number;
  dados_sensiveis: number;
  dados_comuns: number;
  areas_mapeadas: number;
  total_processos: number;
  total_perguntas: number;
  taxa_conclusao: number;
}

export interface EstatisticasQuestionario {
  total_capitulos: number;
  total_titulares: number;
  total_versoes: number;
  percentual_completo: number;
}

export interface EstatisticasTitulares {
  total: number;
  por_categoria: Record<string, number>;
  por_quantidade: Record<string, number>;
  por_faixa_etaria: Record<string, number>;
  total_dados_tratados: number;
}

export interface TendenciasEstatisticas {
  questionarios_ultimo_mes: number;
  questionarios_ultimos_tres_meses: number;
  titulares_ultimo_mes: number;
  crescimento_mensal: boolean;
}

export interface AnaliseConformidade {
  taxa_conclusao: number;
  nivel: 'Baixo' | 'Regular' | 'Bom' | 'Excelente';
  score: number;
}

export interface Recomendacao {
  prioridade: 'Alta' | 'Média' | 'Baixa';
  categoria: string;
  descricao: string;
  impacto: string;
}

export interface DetalhamentoCobertura {
  cobertura_dados: {
    sensiveis: number;
    comuns: number;
    total: number;
  };
  distribuicao_areas: number;
  eficiencia_mapeamento: number;
}

// Interfaces para relatórios
export interface RelatorioEstatisticas {
  estatisticas_gerais: EstatisticasGerais;
  tendencias: TendenciasEstatisticas;
  conformidade: AnaliseConformidade;
  recomendacoes: Recomendacao[];
  detalhamento: DetalhamentoCobertura;
}

export interface ConfigRelatorio {
  tipo: TipoRelatorio;
  formato: FormatoRelatorio;
  questionario_id?: string;
  incluir_dados_sensiveis: boolean;
  incluir_observacoes: boolean;
  incluir_estatisticas: boolean;
  filtro_data_inicio?: Date;
  filtro_data_fim?: Date;
  observacoes_adicionais?: string;
  titulo_personalizado?: string;
}

export interface ValidacaoRelatorio {
  valido: boolean;
  avisos: string[];
  erros: string[];
  estatisticas_previas: any;
  recomendacoes: string[];
}

export interface ProgressoQuestionario {
  porcentagem: number;
  capitulos_completos: number;
  total_capitulos: number;
  titulares_cadastrados: number;
}

export interface ValidacaoQuestionario {
  completo: boolean;
  pendencias: string[];
}

// DTOs para requisições
export interface CreateQuestionarioDTO {
  cliente_id?: string;
  nome: string;
  abordagem?: AbordagemType;
  areas?: string[];
}

export interface VincularCapituloDTO {
  questionario_id: string;
  capitulo_id: string;
  areas_id: string[];
  descricao_personalizada?: string;
}

export interface CreateVersaoRespostasDTO {
  questionario_id: string;
  prazo?: Date;
}

export interface SalvarRespostaDTO {
  value: string[];
  questionario_perguntas_id?: string;
  user_id: string;
  versao_respostas: string;
}

export interface CreateTitularDTO {
  relacao_id: string;
  categoria?: string;
  quantidade?: QuantidadeTitular;
  faixa_etaria?: FaixaEtaria[];
  dados?: DadoTitular[];
  obs_coleta?: string;
  obs_processamento?: string;
  obs_compartilhamento?: string;
  obs_armazenamento?: string;
  finalidade_coleta?: string;
  finalidade_processamento?: string;
  finalidade_compartilhamento?: string;
  finalidade_armazenamento?: string;
  medidas_coleta?: string;
  medidas_processamento?: string;
  medidas_compartilhamento?: string;
  medidas_armazenamento?: string;
}

export interface UpdateStatusVersaoDTO {
  status: StatusVersao;
}

// Tipos para respostas da API
export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message: string;
  timestamp: string;
  pagination?: PaginationMeta;
  error?: string;
}

export interface ApiError {
  success: false;
  message: string;
  error?: string;
  timestamp: string;
  errors?: Array<{
    field: string;
    message: string;
  }>;
}

// Tipos compostos para views
export interface QuestionarioDetalhado extends Questionario {
  cliente?: Cliente;
  capitulos: Array<QuestionarioCapitulo & {
    capitulo?: Processo;
    areas?: Area[];
  }>;
  estatisticas?: EstatisticasQuestionario;
}

export interface TitularDetalhado extends Titular {
  relacao?: QuestionarioCapitulo;
  dados_detalhados?: Array<DadoTitular & {
    dado?: Dado;
  }>;
}

export interface RelatorioMapeamento {
  questionario: Questionario & { cliente?: Cliente };
  capitulos: Array<QuestionarioCapitulo & {
    capitulo?: Processo;
    areas?: Area[];
  }>;
  titulares: TitularDetalhado[];
  versoes: VersaoRespostas[];
  estatisticas?: EstatisticasQuestionario;
  resumo: {
    totalCapitulos: number;
    totalTitulares: number;
    totalVersoes: number;
    ultimaVersao: VersaoRespostas | null;
    percentual_completo?: number;
    possui_dados_sensiveis?: boolean;
  };
}

// Filtros para consultas - todos com suporte a cliente_id
export interface FiltroQuestionarios {
  cliente_id?: string;
  search?: string;
  status?: 'ativo' | 'inativo';
  abordagem?: AbordagemType;
}

export interface FiltroTitulares {
  cliente_id?: string;
  relacao_id?: string;
  search?: string;
  categoria?: string;
  quantidade?: QuantidadeTitular;
}

export interface FiltroAreas {
  cliente_id?: string;
  search?: string;
  padrao?: boolean;
}

export interface FiltroDados {
  tipo?: TipoDado;
  search?: string;
  categoria?: string;
}

export interface FiltroPerguntas {
  search?: string;
  tipo?: string;
  ativo?: boolean;
}

export interface FiltroProcessos {
  cliente_id?: string;
  search?: string;
  tags?: string[];
}

// Interface para relatórios simplificada
export interface RelatorioParams {
  clienteId?: string;
  questionarioId?: string;
  tipo?: TipoRelatorio;
  incluir_dados_sensiveis?: boolean;
  incluir_observacoes?: boolean;
  incluir_estatisticas?: boolean;
  titulo_personalizado?: string;
  observacoes_adicionais?: string;
}

// Interface para hooks simplificada (sem cache)
export interface UseMapeamentosRelatorioReturn {
  // Estados principais
  relatorioModalVisible: boolean;
  loadingQuestionarios: boolean;
  questionarios: Questionario[];
  generatingReport: boolean;

  // Funções principais
  openRelatorioModal: () => void;
  closeRelatorioModal: () => void;
  loadQuestionarios: (filtros?: FiltroQuestionarios) => Promise<void>;
  handleGerarRelatorio: (questionarioId: string, formato?: FormatoRelatorio) => Promise<void>;
  gerarRelatorioRapido: (tipo: TipoRelatorio, params?: RelatorioParams) => Promise<void>;
  visualizarRelatorio: (tipo: string, params: RelatorioParams) => Promise<void>;

  // Funções auxiliares simplificadas
  validarDadosRelatorio?: (tipo: TipoRelatorio, questionarioId?: string, clienteId?: string) => Promise<ValidacaoRelatorio>;
  obterEstatisticasPreview?: (clienteId?: string) => Promise<EstatisticasGerais>;
}

// Health check
export interface HealthCheck {
  status: string;
  timestamp: string;
  service?: string;
}